import $ from "jquery";
import DropzoneLib from 'dropzone';

import Modal from '../../components/Modal';
import Request from '../../components/request';
import Utils from '../../components/utils';
import Vars from "../../vars";

class Conversation {
    constructor(args) {
        let self = this;

        self._state.mode  = args.mode;
        self._state.title = args.title;
        self._state.hash  = args.hash;

        self._init();
    };

    _elems = {
        $content  : $(),
        $support  : $(),
        $dropzone : $()
    };

    _const = {
        entities : 'conversations',
        entity   : 'conversation'
    };

    _state = {
        mode  : null,
        title : '',
        item  : {},
        items : null,
        hash  : ''
    };

    _initMessage = ($message, message) => {
        let self = this;
        $message.find('.conversation-message__answer').click(function(e) {
            e.preventDefault();
            $(window).scrollTop($('body').outerHeight(true) - $(window).height() - $('.footer').height() - 5);

            let quote   = $(this).parent().children('.conversation-message__body').text().replace(/^\s*/,'').replace(/\s*$/,'');
            let quoteId = $(this).parents('.conversation-message').data('id');

            if (quote != '') {
                self._elems.$content.find('.textarea__quote > p > span').text(quote);
                self._elems.$content.find('.textarea__quote').slideDown();
            }
            self._elems.$content.find('input[name=reply_to]').val(quoteId);
            self._elems.$content.find('textarea[name="message[text]"]').focus();
        });
    };

    _bindElements = () => {
        let self = this;

        self._elems.$content = !self._elems.$content.length ? $('.content') : self._elems.$content;
        if(!self._elems.$content.length) return;

        self._elems.$support  = self._elems.$content.find('.js-profile-conversation-support');
        self._elems.$dropzone = self._elems.$content.find('.dropzone');
    };

    _bindUploadPreviousMessages = () => {
        let self = this;

        self._elems.$content.find('.conversation__load-previous-messages').unbind('click').on('click', function(e) {
            e.preventDefault();
            loader.increase();

            Request.send({
                path: '/api/' + self._const.entities + '/' + self._state.hash + '/messages',
                data: { before_message_id: self._state.item.messages[0].id },
                done: function(response) {
                    loader.decrease();

                    response.messages.slice().reverse().forEach(function(message) {
                        let $message = $('<div />').addClass('conversation-message').html(Utils.renderProfileTemplate('conversation-message', {
                            conversation: 	self._state.item,
                            message: 		message,
                            participants:   self._state.item.participants
                        })).attr('data-id', message.id);

                        if (message.user_id == auth.user.id) {
                            $message.addClass('from-me');
                        }

                        $message.prependTo('.conversation__messages');
                        self._initMessage($message, message);
                    });

                    self._state.item.messages = [].concat(response.messages).concat(self._state.item.messages);
                    self._bindUpdateLoadPreviousMessagesLink();
                }
            });
        });
    };

    _bindUpdateLoadPreviousMessagesLink = () => {
        let self = this;
        if (!Object.keys(self._state.item).length) return;

        if (self._state.item.count_of_messages > self._state.item.messages.length) {
            $('.conversation__count-of-previous-messages').text(self._state.item.count_of_messages - self._state.item.messages.length);
            $('.conversation__load-previous-messages').show();
        }
        else {
            $('.conversation__load-previous-messages').hide();
        }
    };

    _bindReply = () => {
        let self = this;

        $(document).on('click', '.js-reply', function(e){
            e.preventDefault();
            let $blockquote = $(this);

            self._toReply($blockquote);
        });
    };

    _toReply = ($blockquote) => {
        let self = this;

        let $message = $('.conversation-message[data-id="' + $blockquote.data('reply_to') + '"]');

        if ($message && $message.length){
            $('html, body').stop().animate({
                'scrollTop': $message.offset().top - 82
            }, 400, 'swing');
            $('.conversation-message').addClass('opacity');
            $message.removeClass('opacity');
            setTimeout(function(){
                $('.conversation-message').removeClass('opacity');
            }, 1500);
        }
        else {
            Request.send({
                path: '/api/' + self._const.entities + '/' + self._state.hash + '/messages',
                data: { before_message_id: messages[0].id },

                done: function(response) {
                    loader.decrease();

                    response.messages.slice().reverse().forEach(function(message) {
                        let $message = $('<div />').addClass('conversation-message').html(Utils.renderProfileTemplate('conversation-message', {
                            conversation: 	conversation,
                            message: 		message,
                            participants:   participants
                        })).attr('data-id', message.id);

                        if (message.user_id == auth.user.id) {
                            $message.addClass('from-me');
                        }

                        $message.prependTo('.conversation__messages');
                        self._initMessage($message, message);
                    });

                    messages = [].concat(response.messages).concat(messages);
                    self._bindUpdateLoadPreviousMessagesLink();

                    self._toReply($blockquote);
                }
            });
        }
    };

    _bindSupport = () => {
        let self = this;
        if (!self._elems.$support.length) return;

        self._elems.$support.unbind('click').on('click', function(e){
            e.preventDefault();

            window.location.href = '/profile#' + self._const.entities + '/support';
        });
    };

    _bindDropzone = () => {
        let self = this;
        if (!self._elems.$dropzone.length) return;

        self._elems.$dropzone.each(function(){
            let dropzone = new DropzoneLib('#' + $(this).attr('id'), {
                url: '/api/conversations/documents/create?api_token=' + auth.user.api_token,

                addRemoveLinks: 	true,
                paramName: 			'document',
                thumbnailWidth: 	78,
                thumbnailHeight: 	78,
                maxFilesize: 		10,
                maxFiles: 			20,
                timeout:            180000,

                dictDefaultMessage: 	'Чтобы загрузить документы, выберите или просто перетащите их в это поле',
            });

            dropzone.processing = 0;

            dropzone.on('processing', function(file) {
                dropzone.processing == 0 && $('.conversation__new-message__button').prop('disabled', true);
                ++dropzone.processing;
            });

            dropzone.on('complete', function(file) {
                --dropzone.processing;
                dropzone.processing == 0 && $('.conversation__new-message__button').prop('disabled', false);
                let response = file.xhr ? JSON.parse(file.xhr.response) : null;
                let $file = $(file._removeLink).parent();

                if (response && response.error) return;

                if (!file.document) {
                    file.document = response ? response.document : null;
                }

                if (file.document) {
                    $('<input />').attr('type', 'hidden').attr('name', 'message[document_ids][]').val(file.document.id).appendTo($file);
                    $('<a />').attr('href', file.document.base + file.document.path).attr('target', '_blank').addClass('dz-link').appendTo($file);

                    $('<a />').attr('href', '#').addClass('dz-remove with-confirmation').html('<i class="fa fa-close" />').appendTo($file).click(function(event) {
                        event.preventDefault();

                        new Modal({
                            title   : 'Удаление документа',
                            content : Utils.renderProfileTemplate('info', {
                                message : 'Вы действительно хотите удалить документ?',

                                buttons : {
                                    one : {
                                        class : 'confirm button--remove',
                                        title : 'Да, удалить'
                                    },
                                    two : {
                                        class : 'button--cancel',
                                        title : 'Нет'
                                    }
                                }
                            }),
                            confirm : function(args) {
                                args.modal.trigger('close');
                                dropzone.removeFile(file);
                            }
                        });
                    });

                    $file.find('.dz-image').addClass('is-' + file.document.extension);
                    $file.find('.dz-image img').remove();
                    $file.addClass('dz-file-preview');
                }
            });

            /*$(this).sortable({
                items     : '.dz-preview',
                cursor    : 'move',
                opacity   : 0.5,
                distance  : 20,
                tolerance : 'pointer',
                helper    : 'clone',
                start     : function() {
                    $(this).children('.dz-preview').removeClass('dz-success');
                }
            });*/
        });
    };

    _bindUI = () => {
        let self = this;

        self._bindSupport();
        self._bindUploadPreviousMessages();
        self._bindUpdateLoadPreviousMessagesLink();
        self._bindReply();
        self._bindDropzone();

        /**/
        self._elems.$content.find('.textarea__quote--close').unbind('click').on('click', function(e){
            e.preventDefault();

            self._elems.$content.find('.textarea__quote').slideUp();
            self._elems.$content.find('.textarea__quote > p > span').text('');
            self._elems.$content.find('input[name=reply_to]').val('');
        });

        $('.conversation__new-message').submit(function(e) {
            e.preventDefault();

            if ($(this).prop('disabled')) return;

            if (!$('.conversation__new-message__textarea').find('textarea').val()) {
                new Modal({
                    title   : 'Ошибка',
                    content : Utils.renderProfileTemplate('info', {
                        message : 'Напишите текст сообщения',
                        buttons : {
                            one : {
                                class : 'confirm button--edit',
                                title : 'Хорошо'
                            },
                            two : null
                        }
                    }),
                    confirm : function(args) {
                        args.modal.trigger('close');
                        $('textarea[name="message[text]"]').focus();
                    }
                });

                return;
            }

            loader.increase();

            Request.send({
                path: 		'/api/' + self._const.entities + '/' + self._state.hash + '/messages/create',
                method: 	'POST',
                data: 		$(this).serialize(),

                done: function(response) {
                    loader.decrease();

                    if (response.error) {
                        return;
                    }

                    let message = response.message;
                    self._state.item.messages.push(message);

                    let $message = $('<div />').addClass('conversation-message').html(Utils.renderProfileTemplate(self._const.entity + '-message', {
                        conversation: 	self._state.item,
                        message: 		message
                    })).attr('data-id', message.id);

                    if (message.user_id == auth.user.id) {
                        $message.addClass('from-me');
                    }

                    $message.appendTo('.conversation__messages');
                    self._initMessage($message, message);

                    $('.conversation__new-message__textarea').each(function() {
                        $(this).find('.textarea__layer').html('<br>');
                        $(this).find('textarea').val('');
                    });

                    $('.textarea__quote').slideUp();
                    $('.textarea__quote > p > span').text('');
                    $('input[name=reply_to]').val('');

                    self._elems.$dropzone.length && self._elems.$dropzone.each(function(){
                        DropzoneLib.forElement('#' + $(this).attr('id')).removeAllFiles(true)
                    });
                },
            });
        });
    };

    _list = () => {
        let self = this;

        Request.send({
            path: '/api/pages/' + self._const.entities,
            page : true,
            done: function(response) {
                loader.decrease();
                Utils.scrollToTop();

                self._state.items   = response[self._const.entities];

                //self.profile.initTariff(response.tariff);

                let breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                    crumbs : [
                        {
                            title : 'Главная',
                            href  : '#'
                        },
                        {
                            title : self._state.title
                        }
                    ],
                    dropdown : null,
                    activate : null
                });

                let actions = response.tariff ? Utils.renderProfileTemplate('actions', {
                    entity : self._const.entity,
                    actions : {
                        support : {
                            title  : 'Обратиться в службу поддержки'
                        }
                    }
                }) : false;

                self._elems.$content.html(Utils.renderProfileTemplate(self._state.mode, {
                    breadcrumbs : breadcrumbs,
                    view        : Vars.views.tile,
                    columns     : 1,
                    entity      : self._const.entity,
                    entities    : self._const.entities,
                    actions     : actions,
                    group       : false,
                    items       : self._state.items.sort(function(a, b){
                        return Date.parse(b.created_at) - Date.parse(a.created_at);
                    }),
                    item_id     : 'hash',
                    detail      : false,
                    card        : function(entity, item){
                        return Utils.renderProfileTemplate(entity, {
                            [entity] : item,
                            mode     : self._state.mode
                        });
                    }
                }));

                self._bindElements();
                self._bindUI();
            }
        });
    };

    _item = () => {
        let self = this;

        Request.send({
            path: '/api/pages/' + self._const.entities + '/' + self._state.hash,
            page : true,
            done: function(response) {
                loader.decrease();
                Utils.scrollToTop();

                self._state.item = response[self._const.entities];

                //self.profile.initTariff(response.tariff);\

                let title = '';

                if (self._state.item.is_support) {
                    title = 'Техническая поддержка';
                } else {
                    self._state.item.participants.forEach(function(participant) {
                        if (participant.id != auth.user.id) {
                            title = participant.name != '' ? participant.name : 'Пользователь #' + participant.id;
                        }
                    })
                }
                document.title = title + '. ' + Vars.title;

                let breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                    crumbs : [
                        {
                            title : 'Главная',
                            href  : '#'
                        },
                        {
                            title : 'Мои диалоги',
                            href  : '#' + self._const.entities
                        },
                        {
                            title : title
                        }
                    ],
                    dropdown : null,
                    activate : null
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._state.mode, {
                    breadcrumbs : breadcrumbs,
                    entities    : self._const.entities,
                    entity      : self._const.entity,
                    item        : self._state.item,
                    card        : function(entity, item){
                        return Utils.renderProfileTemplate(entity, {
                            conversation : item,
                            mode         : self._state.mode
                        });
                    }
                }));

                self._state.item.messages.forEach(function(message) {
                    let $message = $('<div />').addClass('conversation-message').html(Utils.renderProfileTemplate(self._const.entity + '-message', {
                        conversation: 	self._state.item,
                        message: 		message
                    })).attr('data-id', message.id);

                    if (message.user_id == auth.user.id) {
                        $message.addClass('from-me');
                    }

                    $message.appendTo('.conversation__messages');
                    self._initMessage($message, message);
                });

                //$(window).scrollTop($('body').outerHeight(true) - $(window).height() - 5);
                setTimeout(function(){
                    $('html, body').animate({scrollTop: '1000px'});
                }, 300);

                self._bindElements();
                self._bindUI();
            }
        });
    };

    _init = () => {
        let self = this;

        self._bindElements();
        if(!self._elems.$content.length) return;

        if (self._state.mode === Vars.view.list) {
            self._list();
        } else if (self._state.mode === Vars.view.item) {
            self._item();
        }
    }
}

export default Conversation;